<template>
  <b-container class="pt-sm-0 pt-5 px-1 px-sm-3" fluid >
    <div class="overflow-hidden">
      <h2>App Chains</h2>
      <p>Create chains of apps to set order of the modules of quizes and add break between them.</p>
      <!-- app chain flow -->
      <div v-if="Array.isArray(appChainList) && !isLoadingChains" style="border-radius: 8px; overflow: hidden !important;" class="p-4 shadow-sm my-3 bg-white">
        <h3 class="h5 mb-3">
          <i class="fas fa-link me-2 text-primary"></i> &MediumSpace; App Chain Flow
        </h3>
        <div class="d-flex gap-2 align-items-center horizontal-chain-wrapper p-3 custom-horizontal-box">
          <div v-for="(item, index) in appChainList" :key="index" class="d-flex gap-2 align-items-center">
            <!-- Chain Card -->
            <div class="px-3 py-1 border bg-white shadow-sm chain-card">
              <p :title="item?.app_id_name" class="font mb-1 line-clamp-1 pointer" >{{ item?.app_id_name }}</p>
              <!-- text-break -->
              <small class="text-nowrap">Id:&nbsp;{{ item?.app_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy( item?.app_id)"></i></small>
              <div class="mt-1 d-flex align-items-center gap-2">
                <i @click="appEdit(item?.app_id)" class="ri-ball-pen-fill m-0 font-size-18 mr-2 pointer" title="Edit App"></i>
                <i @click="openApp(item?.app_id)" class="fa fa-eye font-size-18 pointer" aria-hidden="true" title="View App"></i>
              </div>
            </div>
            <!-- Chain Card -->
            <!-- Arrow Between Chains -->
            <div v-if="index < appChainList.length - 1 || (index === appChainList?.length - 1 && item?.chain_to_name)" class="arrow-section d-flex flex-column align-items-center mx-3">
              <div class="arrow-icon-container bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center mb-2">
                <i class="fas fa-arrow-right"></i>
              </div>
              <span class="badge bg-secondary text-white small">
                <i class="fas fa-hourglass-half me-1"></i> &MediumSpace; {{ item?.break_before_chain_to || 'N/A' }} &nbsp; min
              </span>
            </div>
            <!-- Arrow Between Chains -->
            <!-- last Chain Card (chain to) -->
            <div v-if="index === appChainList?.length - 1 && item?.chain_to_name" class="px-3 py-1 border bg-white shadow-sm chain-card">
              <p :title="item?.chain_to_name" class="font mb-1 line-clamp-1 pointer" >{{ item?.chain_to_name }}</p>
              <small class="text-nowrap">Id:&nbsp;{{ item?.chain_to }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy( item?.chain_to)"></i></small>
              <div class="mt-1 d-flex align-items-center">
                <i @click="appEdit(item?.chain_to)" class="ri-ball-pen-fill m-0 font-size-18 mr-2 pointer" title="Edit App"></i>
                <i @click="openApp(item?.chain_to)" class="fa fa-eye font-size-18 pointer" aria-hidden="true" title="View App" ></i>
              </div>
            </div>
            <!-- last Chain Card (chain to) -->
          </div>
        </div>
      </div>
      <!-- app chain flow -->
    </div>
    <!--chains main section with add, edit and remove -->
    <div v-if="Array.isArray(appChainList) && !isLoadingChains" class="d-flex flex-column py-4 align-items-center">
      <div v-for="(item, index) in appChainList" :key="index" class="d-flex flex-column flex-lg-row align-items-lg-end mb-3 w-100">
        <div class="col-12 col-lg-8 mx-2 mt-3 mt-lg-0">
          <div class="d-flex justify-content-center justify-content-lg-between w-100">
            <div class="col-4">
              <div class="d-flex justify-content-between align-items-center fs-3 mb-1">
                <div class="d-flex align-items-center">
                  <i class="fa ri-question-answer-fill text-primary"></i>
                  <label class="fw-bolder ml-2 mb-0">App name</label>
                </div>
                <i title="Select the app to chain from." class="fa fa-info-circle text-primary pointer"></i>
              </div>
              <p class="mb-0 border p-1 fw-bolder">{{ item?.app_id_name }}</p>
            </div>
            <div class="col-3 mx-2">
              <div class="d-flex justify-content-between align-items-center fs-3 mb-1">
                <div class="d-flex align-items-center">
                  <i class="fas fa-hourglass-half text-primary"></i>
                  <label class="fw-bolder ml-1 mb-0">Break Timer (Mins)</label>
                </div>
                <i title="Break (timer) in minutes, between 2 quizzes" class="fa fa-info-circle text-primary pointer"></i>
              </div>
              <input :value="changedChainToAppsListObj[index]?.break_before_chain_to ?? ''" @input="updateValue($event, index)" class="py-1 w-100" placeholder="Enter timer value in minutes" type="text">
            </div>
            <div class="col-5">
              <div class="d-flex justify-content-between align-items-center fs-3 mb-1 mx-1">
                <div class="d-flex align-items-center">
                  <i class="fa ri-question-answer-fill text-primary"></i>
                  <label class="fw-bolder ml-2 mb-0">Chained to</label>
                </div>
                <i title="Select the app to chain to." class="fa fa-info-circle text-primary pointer"></i>
              </div>
              <multiselect
                :value="appList.find(app => app.app_id === item?.chain_to || app.app_id === changedChainToAppsListObj[index]?.chain_to) || null"
                @input="onSelectApp($event, item, index)"
                :options="appList"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Pick an app"
                label="app_name"
                track-by="app_id"
                >
                <template #option="props">
                  <span>{{ props.option?.app_name || '' }}</span>
                </template>
                <template #selection="props">
                  <span>{{ props.option?.app_name || '' }}</span>
                </template>
              </multiselect>
            </div>
          </div>
          <label v-if="error[index]" class="text-danger mt-1 ml-1">{{ error[index] }}</label>
        </div>
        <div class="col-12 col-lg-4 d-flex justify-content-center justify-content-lg-start align-items-center mt-3 mt-lg-0 mx-2 my-1">
          <b-button :disabled="appChainList[index]?.app_id === null || appChainList[index]?.chain_to === null ? true : false" @click="openRemoveChainModal(index)" variant="primary" class="btn btn-primary">Remove</b-button>
          <b-button @click="addChain(index)" variant="primary" class="btn btn-primary mx-2">Save</b-button>
          <b-button v-if="index === appChainList?.length - 1" @click="addNewChainRow(index)"  variant="primary" class="btn btn-primary">Add next chain</b-button>
        </div>
      </div>
      <label v-if="addNewChainRowError" class="text-danger">{{ addNewChainRowError }}</label>
    </div>
    <!-- chains main section with add, edit and remove -->
    <!-- spinner -->
    <div style="height: 80dvh;" v-if="isLoadingChains" class="d-flex flex-column justify-content-center align-items-center text-black py-3">
      <b-spinner class="spinner" label="Text Centered"></b-spinner>
      <p style="font-weight: 600;" class="mb-0 mt-3">Loading chains, please wait...</p>
    </div>
     <!-- spinner -->
    <!-- Toast -->
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
    <!-- Toast -->
     <!-- modal -->
    <div
      v-if="showRemoveConfirmationModal"
      class="modal fade show d-block"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editScoreModalLabel"
      :aria-hidden="!showRemoveConfirmationModal"
    >
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content bg-white" style="z-index: 1051; position: relative;">
          <div class="modal-header">
            <h5 class="modal-title">Remove Chains</h5>
            <i class="fa-solid fa-xmark font-size-18 pointer" @click="showRemoveConfirmationModal = false" ></i>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to remove app chain?. All the chained apps after it will also be removed.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showRemoveConfirmationModal = false">Cancel</button>
            <button @click="removeChain()" type="button" class="btn btn-primary">Confirm remove</button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { Apps } from "../../../FackApi/api/apps.js"
import { AppChains } from "../../../FackApi/api/AppChain.js"
import Multiselect from "vue-multiselect"
import Utility from "../../../Utils/utility.js"

export default {
  name: "AppChains",
  components: {
    Multiselect
  },
  data () {
    return {
      appList: [],
      appChainList: null,
      changedChainToAppsListObj: [],
      addNewChainRowError: null,
      error: [],
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "App Chains",
      app_id: null,
      doCopy: Utility.doCopy,
      showRemoveConfirmationModal: false,
      chainIndexToRemove: null,
      isLoadingChains: true
    }
  },
  mounted () {
    this.loadRequiredData()
  },
  methods: {
    /**
     * load RequiredData
     */
    async loadRequiredData () {
      this.app_id = this.$route.params.app_id || null
      socialvue.index()
      this.getAppsList()
      this.getAppChainList()
    },
    /**
     * getAppsList
     */
    async getAppsList () {
      try {
        const appsLists = await Apps.appListConsole()
        if (appsLists.resp_status) {
          this.appList = appsLists.resp_data.data
        }
        else {
          this.appList = []
        }
      }
      catch (err) {
        console.error("Exception occurred at getAppsList() and Exception:", err.message)
      }
    },
    /**
     * getAppsList
     */
    async getAppChainList () {
      this.addNewChainRowError = null
      this.isLoadingChains = true
      this.appChainList = []
      this.changedChainToAppsListObj = []
      try {
        const appsChainLists = await AppChains.AppChainList(this, { app_id: this.app_id })
        if (appsChainLists.resp_status) {
          if (appsChainLists.resp_data.app_ancestor && appsChainLists.resp_data.app_ancestor.length > 0 && appsChainLists.resp_data.app_child && appsChainLists.resp_data.app_child.length > 0) {
            this.appChainList = [...appsChainLists.resp_data.app_ancestor, ...appsChainLists.resp_data.app_child]
            appsChainLists.resp_data.app_ancestor.map(item => (
              this.changedChainToAppsListObj.push({ app_id: item.app_id, chain_to: item.chain_to || null, break_before_chain_to: item.break_before_chain_to || 0 })
            ))
            appsChainLists.resp_data.app_child.map(item => (
              this.changedChainToAppsListObj.push({ app_id: item.app_id, chain_to: item.chain_to || null, break_before_chain_to: item.break_before_chain_to || 0 })
            ))
          }
          else if (appsChainLists.resp_data.app_ancestor && appsChainLists.resp_data.app_ancestor.length > 0) {
            this.appChainList = appsChainLists.resp_data.app_ancestor
            appsChainLists.resp_data.app_ancestor.map(item => (
              this.changedChainToAppsListObj.push({ app_id: item.app_id, chain_to: item.chain_to || null, break_before_chain_to: item.break_before_chain_to || 0 })
            ))
          }
          else if (appsChainLists.resp_data.app_child && appsChainLists.resp_data.app_child.length > 0) {
            this.appChainList = appsChainLists.resp_data.app_child
            appsChainLists.resp_data.app_child.map(item => (
              this.changedChainToAppsListObj.push({ app_id: item.app_id, chain_to: item.chain_to || null, break_before_chain_to: item.break_before_chain_to || 0 })
            ))
          }
          else {
            // handling case where chain is not created for the app_id
            const response = await Apps.appView(this, this.app_id)
            if (response.resp_status && response.resp_data?.data) {
              const responseData = response.resp_data.data
              this.appChainList = [{ app_id: responseData.app_id, app_id_name: responseData.app_name, chain_to: null, chain_to_name: null, break_before_chain_to: 0 }]
              this.changedChainToAppsListObj.push({ app_id: responseData.app_id, chain_to: null, break_before_chain_to: 0 })
            }
          }
        }
        else {
          // handling case where chain is not created for the app_id
          const response = await Apps.appView(this, this.app_id)
          if (response.resp_status && response.resp_data?.data) {
            const responseData = response.resp_data.data
            this.appChainList = [{ app_id: responseData.app_id, app_id_name: responseData.app_name, chain_to: null, chain_to_name: null, break_before_chain_to: 0 }]
            this.changedChainToAppsListObj.push({ app_id: responseData.app_id, chain_to: null, break_before_chain_to: 0 })
          }
        }
        this.isLoadingChains = false
      }
      catch (err) {
        console.error("Exception occurred at getAppChainList() and Exception:", err.message)
        this.isLoadingChains = false
      }
    },
    /**
     * onSelectApp
     */
    onSelectApp (selected, parent, index) {
      this.changedChainToAppsListObj[index].chain_to = selected?.app_id || null
      this.changedChainToAppsListObj[index].app_id = parent.app_id || null

      // clearing error message on select app
      this.clearError(index)
    },
    /**
     * addChain
     */
    async addChain (index) {
      this.addNewChainRowError = null
      const payload = this.changedChainToAppsListObj[index]
      console.log("payload.break_before_chain_to", payload.break_before_chain_to)
      if (!payload.app_id || !payload.chain_to || (payload.break_before_chain_to === null || payload.break_before_chain_to === undefined || payload.break_before_chain_to === "")) {
        if (!payload.app_id) {
          this.$set(this.error, index, "App ID is required.")
        }
        else if (!payload.chain_to) {
          this.$set(this.error, index, "Chain To App is required.")
        }
        else if (payload.break_before_chain_to === null || payload.break_before_chain_to === undefined || payload.break_before_chain_to === "") {
          this.$set(this.error, index, "Break Before Chain To is required.")
        }
        return
      }
      else {
        this.$set(this.error, index, null)
      }
      const response = await AppChains.AppChainEdit(this, payload)
      if (response.resp_status) {
        await this.getAppChainList()
        this.toastMsg = "App chain updated successfully."
        this.toastVariant = "success"
        this.showToast = true
      }
    },
    /**
     * addNewChainRow
     */
    addNewChainRow (index) {
      // checking is any value in last row is null then display error message and return
      if (this.appChainList[index].app_id === null || this.appChainList[index].chain_to === null) {
        this.addNewChainRowError = "Please complete the current chain before adding a new one."
      }
      else {
        // clearing error message and added new row in the appChainList and changedChainToAppsListObj with app_id from last row
        this.addNewChainRowError = null
        this.appChainList.push({ app_id: this.appChainList[index]?.chain_to, app_id_name: this.appChainList[index]?.chain_to_name, chain_to: null, break_before_chain_to: 0 })
        this.changedChainToAppsListObj.push({ app_id: this.appChainList[index]?.chain_to, chain_to: null, break_before_chain_to: 0 })
      }
    },
    /**
     * removeChain
     */
    async removeChain () {
      const index = this.chainIndexToRemove
      try {
        if (!this.appChainList[index]?.chain_to) {
          this.showToast = true
          this.toastMsg = "Cannot remove the app chain as it does not have a chain to app."
          this.toastVariant = "danger"
          return
        }
        if (!this.appChainList[index]?.app_id) {
          this.changedChainToAppsListObj.splice(index, 1)
          this.appChainList.splice(index, 1)
          this.showToast = true
          this.toastMsg = "App chain removed successfully."
          this.toastVariant = "success"
          this.$set(this.error, index, null)
          this.getAppChainList()
          return
        }
        const removeAppsArray = []
        const currentApp = index + 1
        const totalApps = this.appChainList.length
        if (currentApp <= totalApps) {
          for (let i = index; i < totalApps; i++) {
            if (this.appChainList[i]?.app_id && this.appChainList[i]?.chain_to) {
              removeAppsArray.push(this.appChainList[i].app_id)
            }
          }
        }
        const response = await AppChains.AppChainDelete(this, removeAppsArray)
        if (response.resp_status) {
          await this.getAppChainList()
          this.$set(this.error, index, null)
          this.appChainList.splice(index, 1)
          this.changedChainToAppsListObj.splice(index, 1)
          this.showToast = true
          this.toastMsg = "App chain removed successfully."
          this.toastVariant = "success"
        }
        else {
          this.showToast = true
          this.toastMsg = "Failed to remove the app chain."
          this.toastVariant = "danger"
        }
        this.showRemoveConfirmationModal = false
        this.chainIndexToRemove = null
      }
      catch (err) {
        console.error("Exception occurred at removeChain() and Exception:", err.message)
        this.showToast = true
        this.toastMsg = "An error occurred while removing the app chain."
        this.toastVariant = "danger"
        this.showRemoveConfirmationModal = false
        this.chainIndexToRemove = null
      }
    },
    /**
     * updateValue
     */
    updateValue (event, index) {
      if (!this.changedChainToAppsListObj[index]) {
        this.$set(this.changedChainToAppsListObj, index, {})
      }
      // Update the value
      const value = event.target.value
      this.$set(this.changedChainToAppsListObj[index], "break_before_chain_to", value)
      this.clearError(index)
    },
    /**
     * clearError
     */
    clearError (index) {
      this.$set(this.error, index, null)
    },
    /**
     * openRemoveChainModal
     */
    openRemoveChainModal (index) {
      this.showRemoveConfirmationModal = true
      this.chainIndexToRemove = index
    },
    /**
     * appEdit
     */
    appEdit (appId) {
      window.open("/quiz_edit/" + appId, "_blank")
    },
    /**
     * openApp
     */
    openApp (appId) {
      window.open("/quiz_detail/" + appId, "_blank")
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
/* Arrow Section */
.arrow-icon-container {
  width: 36px;
  height: 36px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.arrow-icon-container:hover {
  transform: scale(1.1);
}

/* Scrollbar Styling */
.horizontal-chain-wrapper::-webkit-scrollbar {
  height: 8px;
}

.horizontal-chain-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.horizontal-chain-wrapper::-webkit-scrollbar-thumb {
  background: var(--bs-primary);
  border-radius: 10px;
}

.horizontal-chain-wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--bs-primary-dark);
}

.custom-horizontal-box {
  width: 100% !important;
  background-color: rgb(239, 239, 243) !important;
  border-radius: 12px !important;
  overflow-x: auto !important;
}
/* Chain Card Styles */
.chain-card {
  width:100%;
  position: relative;
  min-width: 280px;
  max-width: 360px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  border-radius: 8px;
}
.chain-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.2) !important;
}
.font{
  font-size: 1.1rem;
  font-weight: 600;
}
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
